import Vue from "vue";
import App from "./App.vue";
import vuetify from "./plugins/vuetify";
// import 'flag-icons/css/flag-icons.min.css';
import router from "./router";
import store from "./store";

require("@/store/subscriber");

require("./mixin.js");
require("./axios.js");
require('./filters.js')


// Import and register permission mixin globally
import permissionMixin from "@/mixins/permissionMixin";
Vue.mixin(permissionMixin);

Vue.config.productionTip = false;

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

import CryptoJS from "crypto-js";
window.CryptoJS = CryptoJS;
// Vue.component("CryptoJS", CryptoJS);

// Import and register Laravel Echo globally
import echo from "./plugins/echo";
Vue.prototype.$echo = echo;

store.dispatch("auth/attempt", localStorage.getItem("token")).then(() => {
  new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
  }).$mount("#app");
});
